import { useState, useCallback } from 'react';
import { addDays, addWeeks, addMonths, format } from 'date-fns';

export const useRecurrencia = () => {
  const [esRecurrente, setEsRecurrente] = useState(false);
  const [recurrencia, setRecurrencia] = useState({
    tipo: 'semanal',
    fin_tipo: 'sesiones',
    num_sesiones: 8,
    fecha_fin: ''
  });

  // Generar fechas de citas recurrentes
  const generarFechasRecurrentes = useCallback((fechaInicio, recurrenciaConfig) => {
    const fechas = [];
    let fechaActual = new Date(fechaInicio);

    if (recurrenciaConfig.fin_tipo === 'sesiones') {
      for (let i = 0; i < recurrenciaConfig.num_sesiones; i++) {
        fechas.push(format(fechaActual, 'yyyy-MM-dd'));

        if (recurrenciaConfig.tipo === 'semanal') {
          fechaActual = addWeeks(fechaActual, 1);
        } else if (recurrenciaConfig.tipo === 'quincenal') {
          fechaActual = addWeeks(fechaActual, 2);
        } else if (recurrenciaConfig.tipo === 'mensual') {
          fechaActual = addMonths(fechaActual, 1);
        } else if (recurrenciaConfig.tipo === 'diaria') {
          fechaActual = addDays(fechaActual, 1);
        }
      }
    } else if (recurrenciaConfig.fin_tipo === 'fecha') {
      const fechaFinTime = new Date(recurrenciaConfig.fecha_fin).getTime();

      while (fechaActual.getTime() <= fechaFinTime) {
        fechas.push(format(fechaActual, 'yyyy-MM-dd'));

        if (recurrenciaConfig.tipo === 'semanal') {
          fechaActual = addWeeks(fechaActual, 1);
        } else if (recurrenciaConfig.tipo === 'quincenal') {
          fechaActual = addWeeks(fechaActual, 2);
        } else if (recurrenciaConfig.tipo === 'mensual') {
          fechaActual = addMonths(fechaActual, 1);
        } else if (recurrenciaConfig.tipo === 'diaria') {
          fechaActual = addDays(fechaActual, 1);
        }
      }
    }

    return fechas;
  }, []);

  // Validar recurrencia
  const validarRecurrencia = useCallback((config) => {
    if (!config.tipo) return 'Selecciona tipo de recurrencia';

    if (config.fin_tipo === 'sesiones') {
      if (!config.num_sesiones || config.num_sesiones < 2) {
        return 'Mínimo 2 sesiones';
      }
      if (config.num_sesiones > 52) {
        return 'Máximo 52 sesiones';
      }
    } else if (config.fin_tipo === 'fecha') {
      if (!config.fecha_fin) {
        return 'Especifica fecha de fin';
      }
    }

    return null;
  }, []);

  // Obtener descripción legible de recurrencia
  const getRecurrenciaDescripcion = useCallback((config) => {
    const tipoTexto = {
      diaria: 'Diaria',
      semanal: 'Semanal',
      quincenal: 'Quincenal',
      mensual: 'Mensual'
    }[config.tipo] || '';

    if (config.fin_tipo === 'sesiones') {
      return `${tipoTexto}, ${config.num_sesiones} sesiones`;
    } else {
      const fecha = new Date(config.fecha_fin).toLocaleDateString('es-ES');
      return `${tipoTexto}, hasta ${fecha}`;
    }
  }, []);

  return {
    esRecurrente,
    recurrencia,
    setEsRecurrente,
    setRecurrencia,
    generarFechasRecurrentes,
    validarRecurrencia,
    getRecurrenciaDescripcion
  };
};
